<template>
    <v-card class="card__steps py-2 pl-5 pr-2">
        <card-schedule-installation-circle :step="step" ></card-schedule-installation-circle>
        <p class="step__title font-weight-bold flex-d align-baseline" :class="{'text-white':step !== 1}">
            <v-icon class="mb-1" color="#66369B" :class="{'text-white':step !== 1}">{{icon}}</v-icon>
            {{ title }}
        </p>
        <p class="card__content">{{ content }}</p>
    </v-card>
</template>

<script>

import CardScheduleInstallationCircle from '@/components/CardScheduleInstallationCircle.vue'

export default {
  name: 'CardScheduleInstallation.vue',

  components: {
    CardScheduleInstallationCircle,
  },

  props: {
    step: {
        type: Number,
        default: -1,
    },
    icon: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    }
  },
}
</script>

<style scoped>
    .card__steps {
        border-radius: 12px;
        border: 0.50px var(--v-primary-base) solid;
        width: 100%;
        margin-left: 70px;
        background-color: #F2F1FF;
    }
    .step__title {
        width: 100%;
        color: var(--v-primary-base);
        font-size: 20px;  
        font-weight: 500; 
        word-wrap: break-word;
        margin-bottom: 0px;
        padding-left: 20px;
        padding-right: 20px;
    }
    .text-white {
        color: white !important;
    }
    .card__content {
        font-size: 18px;
        font-weight: 400; 
        word-wrap: break-word;
        padding-left: 20px;
        padding-right: 20px;
    }

    @media screen and (max-width: 600px) {
        .card__steps {
            margin-left: 0 !important;
        }
    }
</style>